import { Tab, TabList } from '@fluentui/react-components';
import { useState } from 'react';

import { BodyPanel } from '../BodyPanel/BodyPanel.js';
import { HeadersPanel } from '../HeadersPanel/HeadersPanel.js';
import { ParamsPanel } from '../ParamsPanel/ParamsPanel.js';

import type {
  RequestPanelProps,
  RequestTab,
} from './RequestPanel.interface.js';
import { useStyles } from './RequestPanel.style.js';

export function RequestPanel({
  params,
  body,
  headers,
  vars,
  onParamsChange,
  onBodyChange,
  onHeadersChange,
  onVarsChange,
}: RequestPanelProps) {
  const styles = useStyles();
  const [activeTab, setActiveTab] = useState<RequestTab>('body');

  return (
    <div className={styles.root}>
      <TabList
        className={styles.tabList}
        selectedValue={activeTab}
        onTabSelect={(_, d) => setActiveTab(d.value as RequestTab)}
        size="small"
      >
        <Tab value="params">Params</Tab>
        <Tab value="body">Body</Tab>
        <Tab value="headers">Headers</Tab>
        <Tab value="vars">Vars</Tab>
        <Tab value="settings">Settings</Tab>
      </TabList>

      <div className={styles.content}>
        {activeTab === 'params' && (
          <ParamsPanel pairs={params} onChange={onParamsChange} />
        )}
        {activeTab === 'body' && (
          <BodyPanel body={body} vars={vars} onChange={onBodyChange} />
        )}
        {activeTab === 'headers' && (
          <HeadersPanel headers={headers} onChange={onHeadersChange} />
        )}
        {activeTab === 'vars' && (
          <ParamsPanel
            pairs={vars}
            onChange={onVarsChange}
            placeholder={{ key: 'variable name', value: 'value' }}
          />
        )}
        {activeTab === 'settings' && (
          <div style={{ padding: '1rem', color: 'gray' }}>
            Settings coming soon
          </div>
        )}
      </div>
    </div>
  );
}
